import Cookies from 'js-cookie';
/**
 * Implement Gatsby's Browser APIs in this file.  
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// You can delete this file if you're not using it

function setCookies() {
  function getParameterByName(name) {
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
      results = regex.exec(window.location.search);
    return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
  }

  // Give the URL parameters variable names
  var utm_source = getParameterByName('utm_source');
  var utm_medium = getParameterByName('utm_medium');
  var utm_campaign = getParameterByName('utm_campaign');

  if(utm_source != "" && !Cookies.get("utm_source")) {
    Cookies.set('utm_source', utm_source, { expires: 365 });
  }
  if(utm_medium != "" && !Cookies.get("utm_medium")) {
    Cookies.set('utm_medium', utm_medium, { expires: 365 });
  }
  if(utm_campaign != "" && !Cookies.get("utm_campaign")) {
    Cookies.set('utm_campaign', utm_campaign, { expires: 365 });
  }
  if(document.referrer != "" && !Cookies.get("referrer")) {
    Cookies.set('referrer', document.referrer, { expires: 365 });
  }
}

export const onClientEntry = () => {
  setCookies();
}
